import React from 'react';
import { useMainDealersGroupBannerPresenter } from './MainDealersGroupBanner.presenter';

import { DesktopBanner } from 'components/uikit/DesktopBanner/DesktopBanner';
import { ECreditCalcLImg } from 'assets/images';

export const MainDealersGroupBanner = () => {
  const presenter = useMainDealersGroupBannerPresenter();

  if (!presenter.isBannerVisible) {
    return null;
  }

  return (
    <DesktopBanner
      onlyDescription={
        <>
          Подавайте кредитные заявки на новые автомобили {presenter.getDealersGroupBanner()} только
          через платформу eCredit. Закрыть заявку необходимо в день
          <br />
          фактической выдачи кредита
        </>
      }
      Img={<ECreditCalcLImg />}
      onClick={presenter.handleCloseBanner}
      dataTest="DealersGroupBanner"
    />
  );
};
